import { tracking } from '@iwoca/frontend-tracking-library';
import { Icon, Button } from '@iwoca/orion';
import cn from 'classnames';
import { ControlLabel } from 'react-bootstrap';

import styles from './VATQuestion.module.css';

export const VATQuestion = ({ field }) => {
    const hasError = field.touched && field.error;

    return (
        <div
            className={cn({
                invalid: hasError
            })}>
            <ControlLabel>Is the business VAT registered?</ControlLabel>
            <div className="error" data-testid="vat-error">
                {field.error}
            </div>
            <div className={styles.vatButtons}>
                <Button
                    data-testid="vat-yes"
                    className={cn(styles.oldSignupStyleBtn, {
                        [styles.active]: field.value === true
                    })}
                    onClick={() => {
                        tracking.ampli.formFieldCompleted({
                            form_field: 'vat_registered'
                        });

                        field.onChange(true);
                    }}
                    value={true}
                    variant="tertiary"
                    size="small"
                    type="button">
                    <Icon icon="checkDefault" /> Yes
                </Button>
                <Button
                    data-testid="vat-no"
                    className={cn(styles.oldSignupStyleBtn, {
                        [styles.active]: field.value === false
                    })}
                    onClick={() => {
                        tracking.ampli.formFieldCompleted({
                            form_field: 'vat_registered'
                        });

                        field.onChange(false);
                    }}
                    value={false}
                    variant="tertiary"
                    size="small"
                    type="button">
                    <Icon icon="timesDefault" /> No
                </Button>
            </div>
        </div>
    );
};
